import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getRoleDetails = createAsyncThunk('roles/getRoleDetails',
  async (id, { rejectWithValue }) => {
    try {
      const { data: role } = await authGet(`/roles/${id}`);
      return role;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getRoleDetails;
